module.exports = __webpack_public_path__ + "static/media/a3.cc4b0bf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xubin/a3.mp3
// module id = d3gt
// module chunks = 0